module.exports = __webpack_public_path__ + "static/Portrait-of-Valentin-min-33de27a3d58de1baa9ced2c8b2d402e7.webp";